const UPDATE_ORDER_SETTINGS_SUCCESS_TEXT = "Les paramètres des commandes ont été modifiés.";
export const UPDATE_ORDER_SETTINGS_SUCCESS = UPDATE_ORDER_SETTINGS_SUCCESS_TEXT;


const ADD_ORDER_SHIFT_SUCCESS_TEXT = "L'horaire a été ajouté.";
const DELETE_ORDER_SHIFT_SUCCESS_TEXT = "L'horaire a été supprimé.";
const UPDATE_ORDER_SHIFT_SUCCESS_TEXT = "L'horaire a été modifié.";
export const ADD_ORDER_SHIFT_SUCCESS = ADD_ORDER_SHIFT_SUCCESS_TEXT;
export const DELETE_ORDER_SHIFT_SUCCESS = DELETE_ORDER_SHIFT_SUCCESS_TEXT;
export const UPDATE_ORDER_SHIFT_SUCCESS = UPDATE_ORDER_SHIFT_SUCCESS_TEXT;


const ADD_ORDER_PRODUCT_SUCCESS_TEXT = "Le produit a été ajouté.";
const DELETE_ORDER_PRODUCT_SUCCESS_TEXT = "Le produit a été supprimé.";
const UPDATE_ORDER_PRODUCT_SUCCESS_TEXT = "Le produit a été modifié.";
export const ADD_ORDER_PRODUCT_SUCCESS = ADD_ORDER_PRODUCT_SUCCESS_TEXT;
export const DELETE_ORDER_PRODUCT_SUCCESS = DELETE_ORDER_PRODUCT_SUCCESS_TEXT;
export const UPDATE_ORDER_PRODUCT_SUCCESS = UPDATE_ORDER_PRODUCT_SUCCESS_TEXT;


const UPDATE_ORDER_SUCCESS_TEXT = "Le commande a été mise à jour.";
export const UPDATE_ORDER_SUCCESS = UPDATE_ORDER_SUCCESS_TEXT;

const ACTIVATE_STRIPE_SUCCESS_TEXT = "Stripe a été activé avec succès.";
export const ACTIVATE_STRIPE_SUCCESS = ACTIVATE_STRIPE_SUCCESS_TEXT;

const DEACTIVATE_STRIPE_SUCCESS_TEXT = "Stripe a été désactivé avec succès.";
export const DEACTIVATE_STRIPE_SUCCESS = DEACTIVATE_STRIPE_SUCCESS_TEXT;


// WEBPACK FOOTER //
// ./src/successes/orders.js